module.exports = __webpack_public_path__ + "img/029-boy-11.22e38766.svg";